import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, isRef as _isRef } from "vue"

const _hoisted_1 = { class: "payment-notification-card" }
const _hoisted_2 = { class: "payment-notification-card__header" }
const _hoisted_3 = { class: "payment-notification-card__cost" }
const _hoisted_4 = { class: "payment-notification-card__body" }
const _hoisted_5 = { class: "payment-notification-card__count" }
const _hoisted_6 = {
  key: 0,
  class: "payment-notification-card__title"
}

import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useAddIdent } from '@/composables/useAddIdent'
import { useConfig } from '@/composables/config';

import '@/components/common/SmPaymentCard/style.scss';
import { formatNumberToLocale } from '@/utils/formatNumberToLocale';
import SmIcon from '@/components/ui/SmIcon/SmIcon.vue';
import SmSecondButton from '@/components/ui/buttons/SmSecondButton/SmSecondButton.vue';
import AddIdentModal from '@/components/common/AddIdent/AddIdentModal.vue';

// [START] Types and interfaces
interface IProps {
  cost: number;
  comission: number;
  count: number;
  canPayForAllAccounts: boolean;
}
// [END] Types and interfaces


export default /*#__PURE__*/_defineComponent({
  __name: 'SmPaymentCard',
  props: {
    cost: { default: 0 },
    comission: {},
    count: { default: 0 },
    canPayForAllAccounts: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const router = useRouter();
const { getAppSettings } = useConfig();

const { t } = useI18n();
const { showAddIdentModal, handleAddNewIdent } = useAddIdent();
const appSettings = getAppSettings();
const isLegalAccount = appSettings?.allowedAccountTypes === 1
// [START] Props

// [END] Props

// [START] Computed
const stringCost = computed(() => formatNumberToLocale(props.cost));
// [END] Computed

const textButton = (count: number): string => {
  return count ? t('pay_all') : t('add_personal_account');
}

function handlePayAll() {
  if (props.count && props.canPayForAllAccounts) {
    router.push({ name: 'PaymentAll' });
    return;
  }

  if(props.count && !props.canPayForAllAccount) {
    router.push({ name: 'Payment' });
    return;
  }

  handleAddNewIdent();
}

// function onPayAll() {
//   if (!props.canPayForAllAccounts) return;

//   router.push({ name: 'PaymentAll' });
// }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(stringCost.value) + " ₽", 1),
      _createVNode(SmIcon, {
        name: "RoubleCircle",
        class: "payment-notification-card__icon"
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("p", _hoisted_5, _toDisplayString(_unref(t)(isLegalAccount ? 'contracts' : 'idents', props.count)), 1),
      (_ctx.count)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_unref(t)('pending_payment')), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(SmSecondButton, { onClick: handlePayAll }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(textButton(_ctx.count)), 1)
      ]),
      _: 1
    }),
    _createVNode(AddIdentModal, {
      modelValue: _unref(showAddIdentModal),
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(showAddIdentModal) ? (showAddIdentModal).value = $event : null))
    }, null, 8, ["modelValue"])
  ]))
}
}

})